export class StdLookupAttribute {
    id: number;
    value: string;
}
